import { render, staticRenderFns } from "./ReturnNode.vue?vue&type=template&id=61ab8d84&"
import script from "./ReturnNode.vue?vue&type=script&lang=js&"
export * from "./ReturnNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports